import React, { forwardRef, SyntheticEvent } from 'react'
import type { Ref } from 'react'
import clsx from 'clsx'

import { getLabel } from 'helpers/language'
import { isWindow } from 'helpers/common'
import { IconCloseCircle } from '../Icons'

export interface ChipProps {
  id?: string
  name?: string
  label: string
  className?: string
  classIcon?: string
  isShortText?: boolean
  disabled?: boolean
  onClose: (e: SyntheticEvent) => void
}

function Chip(props: ChipProps, ref: Ref<HTMLDivElement>): JSX.Element {
  const {
    onClose,
    className,
    label,
    disabled = false,
    isShortText = false,
    classIcon = '',
    ...others
  } = props

  const chipProps = {
    ...others,
    className: clsx('chip', className, `${isShortText ? 'fixWidth' : ''}`),
  }

  const _handleClick = (e: SyntheticEvent): void => {
    if (disabled) {
      return undefined
    }

    onClose(e)
  }

  return (
    <div ref={ref} {...chipProps}>
      <label
        htmlFor='chip label'
        className={clsx(
          '',
          isShortText && 'short-text',
          isWindow && 'chip__window-label',
        )}
      >
        {getLabel(label)}
      </label>
      <span onClick={_handleClick} data-testid='chip-close'>
        <IconCloseCircle
          className={`icon--gray-close-icon-chip chip__close ${classIcon}`}
        />
      </span>
    </div>
  )
}

export default forwardRef(Chip)
